import { api } from '../common.api';

interface VideoResponse {
  question1Url: string | null;
  question2Url: string | null;
  question3Url: string | null;
}

interface UploadVideoResponse {
  filename: string;
  questionId: number;
}

export const videoApi = api.injectEndpoints({
  endpoints: (build) => ({
    uploadVideo: build.mutation<UploadVideoResponse, { jobseekerId: number; questionId: number; formData: FormData }>({
      query: ({ jobseekerId, questionId, formData }) => {
        formData.append('questionId', questionId.toString());
        return {
          url: `/jobseeker/${jobseekerId}/videos/upload`,
          method: 'POST',
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: ['Jobseeker'],
    }),
    getVideos: build.query<VideoResponse, number>({
      query: (jobseekerId) => ({
        url: `/jobseeker/${jobseekerId}/videos`,
        method: 'GET',
      }),
      providesTags: ['Jobseeker'],
    }),
    getVideoStream: build.query<Blob, { jobseekerId: number; questionId: number }>({
      query: ({ jobseekerId, questionId }) => ({
        url: `/jobseeker/${jobseekerId}/videos/${questionId}/stream`,
        method: 'GET',
        responseHandler: async (response: Response) => {
          if (!response.ok) {
            return response.json();
          }
          return response.blob();
        },
      }),
      providesTags: ['Jobseeker'],
    }),
    deleteVideo: build.mutation<{ message: string }, { jobseekerId: number; questionId: number }>({
      query: ({ jobseekerId, questionId }) => ({
        url: `/jobseeker/${jobseekerId}/videos/${questionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Jobseeker'],
    }),
  }),
});

export const { useUploadVideoMutation, useGetVideosQuery, useGetVideoStreamQuery, useDeleteVideoMutation } = videoApi;
